// extracted by mini-css-extract-plugin
export default {"decorator_button":"uNp68F"};